import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'hyperscene-viewer',
  templateUrl: './hyperscene-viewer.component.html',
  styleUrls: ['./hyperscene-viewer.component.scss'],
  standalone: false,
})
export class HypersceneViewerDemo {
  public readonly sceneOnly: boolean;
  public readonly debug: boolean;

  constructor(route: ActivatedRoute) {
    this.sceneOnly = route.snapshot.data['sceneOnly'] === true;
    this.debug = route.snapshot.data['debug'] === true;
  }
}
